import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { I18n } from 'i18n-js';
import { PERSONAL_EMAIL_REGXP, EMAIL_REGXP } from '../../shared/Constants';
import RecruiterRegistrationForm from './RecruiterRegistrationForm';
import translations from '../../locales.json';

const i18n = new I18n(translations);

const validationSchema = Yup.object({
  firstName: Yup.string().required(i18n.t('js.sign_up.recruiter.validation.name.first')),
  lastName: Yup.string().required(i18n.t('js.sign_up.recruiter.validation.name.last')),
  email: Yup.string().required(i18n.t('js.sign_up.recruiter.validation.email.email'))
    .matches(EMAIL_REGXP, i18n.t('js.sign_up.recruiter.validation.email.invalid'))
    .matches(PERSONAL_EMAIL_REGXP, i18n.t('js.sign_up.recruiter.validation.email.business')),
  password: Yup.string().required(i18n.t('js.sign_up.recruiter.validation.password.password'))
    .min(8, i18n.t('js.sign_up.recruiter.validation.password.short'))
    .matches(/[a-z]/, i18n.t('js.sign_up.recruiter.validation.password.lowercase'))
    .matches(/[A-Z]/, i18n.t('js.sign_up.recruiter.validation.password.uppercase'))
    .matches(/[0-9]/, i18n.t('js.sign_up.recruiter.validation.password.number')),
  passwordConfirmation: Yup.string().required(i18n.t('js.sign_up.recruiter.validation.password.confirmation'))
    .oneOf([Yup.ref('password')], i18n.t('js.sign_up.recruiter.validation.password.confirmation_mismatch')),
  validTermService: Yup.boolean().oneOf([true]).required(i18n.t('js.sign_up.recruiter.validation.term_service')),
});

const RecruiterRegistration = ({ enqueueSnackbar }) => {
  const values = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    validTermService: false,
  };

  return (
    <Formik
      render={formikProps => (
        <RecruiterRegistrationForm {...formikProps} enqueueSnackbar={enqueueSnackbar} />
      )}
      initialValues={values}
      validationSchema={validationSchema}
    />
  );
};

RecruiterRegistration.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default RecruiterRegistration;
